import { render, staticRenderFns } from "./SignupFormSaveButton.vue?vue&type=template&id=44e57f90&scoped=true"
import script from "./SignupFormSaveButton.vue?vue&type=script&lang=js"
export * from "./SignupFormSaveButton.vue?vue&type=script&lang=js"
import style0 from "./SignupFormSaveButton.vue?vue&type=style&index=0&id=44e57f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e57f90",
  null
  
)

export default component.exports